module.exports = __webpack_public_path__ + "static/media/WAVE.21dbd028.svg";